'use strict';

/**
 * @private
 * @function
 * @description generate and inject inline styles from provided [data-inline-styles] attribute
 * @see scripts:util/ResourceHelper.getInlineMargin
 */
function generateMarginObject() {
    let $modules = $('.js-acf-inline-style'),
        $moduleId,
        $style,
        stylesObject;

    const breakpointsMap = {
        0: '@media screen and (min-width: 320px)',
        1: '@media screen and (min-width: 768px)',
        2: '@media screen and (min-width: 1024px)',
        3: '@media screen and (min-width: 1680px)'
    };

    $modules.map(function (i, el) {
        $moduleId = $(el).attr('id');
        $style = $(el).find('style');
        stylesObject = JSON.parse($style.attr('data-inline-styles'));

        var counter = 0,
            output = '';

        for (counter; counter < stylesObject.length; counter++) {
            // Prevent generating styles for non-existing breakpoints in breakpointsMap object.
            if (counter <= 3) {
                output += `
                    ${breakpointsMap[counter]} {
                        [id="${$moduleId}"] ${JSON.stringify(stylesObject[counter]).replace(/,|"/g, '')}
                    }
                `;
            }
        }

        $style.text(output);
    });
}

exports.init = generateMarginObject;
